<template>
  <div class="notice-list">
    <associationNotice @changePage="changePage" @click="toDetails" :list="notice" :total="noticeTotal" v-loading="loading"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue'
import {dynamics} from '@/api/api.js'
import {mapMutations} from 'vuex'
import {findRoute} from '@/utils/routerHelper.js'

export default {
  components:{
    associationNotice
  },
  data(){
    return {
      loading:true,
      notice:[],
      noticeTotal:0,
      currentPage:1
    }
  },
  created(){
    this.getInfo()
  },
  methods:{
    ...mapMutations('routerData',['changeRouterList']),
    getInfo(){
      dynamics({
        current:this.currentPage,
        size:16,
        type:10
      }).then(res=>{
        this.loading=false
        if(res.data.code==200){
          let data=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
          this.notice=data
          this.noticeTotal=res.data.data.total
        }
      })
    },
    toDetails(data){
      this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
      )
      let routerList=[]
      let routers = ['/associationNews','associationNewsNotice', '/associationNews/details'];
      for (let i = 0; i < routers.length; i++) {
        let routerData=findRoute(this.$router.options.routes, routers[i])
         routerList.push(routerData)
      }
      this.changeRouterList(routerList)
    },
    getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
    changePage(page){
      this.currentPage=page
      this.getInfo()
    }
  }
}
</script>

<style lang="less" scoped>
.notice-list {
  width: 100%;
}
</style>
